import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const cardTokens = {
  shared: {
    'shape-corner-radius': 'border-radius-03',
    'shape-border-width': 'border-width-01',
    'shape-border-color': 'shape-color-stroke-primary',
    'shape-color': 'shape-color-background-primary',
    shadow: 'shadow-low',
  },
};

const CardContainer = styled.div`
  border: ${({ theme, tokens, withBorder }) =>
    !withBorder
      ? 'none'
      : `${theme.borderWidth(tokens['shape-border-width'])} solid ${theme.color(
          tokens['shape-border-color'],
        )}`};
  width: 100%;
  height: 100%;
  border-radius: ${({ theme, tokens }) =>
    theme.borderRadius(tokens['shape-corner-radius'])};
  background-color: ${({ theme, tokens }) =>
    theme.color(tokens['shape-color'])};
  box-shadow: ${({ theme, tokens, withShadow }) =>
    !withShadow ? 'none' : theme.boxShadow(tokens.shadow)};
`;

const CardComponent = React.forwardRef(
  ({ withShadow, withBorder, children, ...props }, ref) => (
    <CardContainer
      ref={ref}
      withShadow={withShadow}
      withBorder={withBorder}
      tokens={cardTokens}
      {...props}
    >
      {children}
    </CardContainer>
  ),
);

CardComponent.defaultProps = {
  withShadow: true,
  withBorder: true,
};

CardComponent.propTypes = {
  children: PropTypes.node,
  withShadow: PropTypes.bool,
  withBorder: PropTypes.bool,
};

CardComponent.displayName = 'CardContainer';

export default CardComponent;
